export default [
    {
        id: '4-snowflakes',
        title: '4 Snowflakes',
        image: '/assets/images/pillows/pp4SnowflakesT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: '4 Snowflakes',
                image: '/assets/images/pillows/pp4Snowflakes.jpg'
            }
        ]
    },
    {
        id: 'abstract',
        title: 'Abstract',
        image: '/assets/images/pillows/ppAbstractT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Abstract',
                image: '/assets/images/pillows/ppAbstract.jpg'
            }
        ]
    },
    {
        id: 'pp-boogie',
        title: 'Boogie',
        image: '/assets/images/pillows/ppBoogieT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Boogie',
                image: '/assets/images/pillows/ppBoogie.jpg'
            }
        ]
    },
    {
        id: 'bright-stripes',
        title: 'Bright Stripes',
        image: '/assets/images/pillows/ppBrightStripesT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Bright Stripes',
                image: '/assets/images/pillows/ppBrightStripes.jpg'
            }
        ]
    },
    {
        id: 'chess',
        title: 'Chess',
        image: '/assets/images/pillows/ppChessT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Chess',
                image: '/assets/images/pillows/ppChess.jpg'
            }
        ]
    },
    {
        id: 'diamond-spiral',
        title: 'Diamond Spiral',
        image: '/assets/images/pillows/ppDiamondSpiralT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Diamond Spiral',
                image: '/assets/images/pillows/ppDiamondSpiral.jpg'
            }
        ]
    },
    {
        id: 'fading-star',
        title: 'Fading Star',
        image: '/assets/images/pillows/ppFadingStarT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Fading Star',
                image: '/assets/images/pillows/ppFadingStar.jpg'
            }
        ]
    },
    {
        id: 'pp-diamonds',
        title: 'Diamonds',
        image: '/assets/images/pillows/ppFlDT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Diamonds',
                image: '/assets/images/pillows/ppFDiamonds.jpg'
            },
            {
                image: '/assets/images/pillows/ppFlD.jpg'
            },
            {
                image: '/assets/images/pillows/ppFlDT.jpg'
            }
        ]
    },
    {
        id: 'pp-floating-diamonds',
        title: 'Floating Diamonds',
        image: '/assets/images/pillows/ppFloatingDiamondsT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Floating Diamonds',
                image: '/assets/images/pillows/ppFloatingDiamonds.jpg'
            }
        ]
    },
    {
        id: 'floating-star',
        title: 'Floating Star',
        image: '/assets/images/pillows/ppFloatingStarT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Floating Star',
                image: '/assets/images/pillows/ppFloatingStar.jpg'
            }
        ]
    },
    {
        id: 'folded-star',
        title: 'Folded Star',
        image: '/assets/images/pillows/ppFoldedStarT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Folded Star',
                image: '/assets/images/pillows/ppFoldedStar.jpg'
            }
        ]
    },
    {
        id: 'interlaced-star',
        title: 'Interlaced Star',
        image: '/assets/images/pillows/ppInterlacedStarT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Interlaced Star',
                image: '/assets/images/pillows/ppInterlacedStar.jpg'
            }
        ]
    },
    {
        id: 'pp-jewel-boxes',
        title: 'Jewel Boxes',
        image: '/assets/images/pillows/ppJewelBoxesT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Jewel Boxes',
                image: '/assets/images/pillows/ppJewelBoxes.jpg'
            }
        ]
    },
    {
        id: 'landscape',
        title: 'Landscape',
        image: '/assets/images/pillows/ppLandscapeT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Landscape',
                image: '/assets/images/pillows/ppLandscape.jpg'
            }
        ]
    },
    {
        id: 'leaf',
        title: 'Leaf',
        image: '/assets/images/pillows/ppLeafT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Leaf',
                image: '/assets/images/pillows/ppLeaf.jpg'
            }
        ]
    },
    {
        id: 'leaves',
        title: 'Leaves',
        image: '/assets/images/pillows/ppLeavesT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Leaves',
                image: '/assets/images/pillows/ppLeaves.jpg'
            }
        ]
    },
    {
        id: 'new-boogie',
        title: 'New Boogie',
        image: '/assets/images/pillows/ppNewBoogieT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'New Boogie',
                image: '/assets/images/pillows/ppNewBoogie.jpg'
            }
        ]
    },
    {
        id: 'ohio-star',
        title: 'Ohio Star',
        image: '/assets/images/pillows/PPOhioStarT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Ohio Star',
                image: '/assets/images/pillows/PPOhioStar.jpg'
            }
        ]
    },
    {
        id: 'parquet',
        title: 'Parquet',
        image: '/assets/images/pillows/ppParquetT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Parquet',
                image: '/assets/images/pillows/ppParquet.jpg'
            }
        ]
    },
    {
        id: 'plains',
        title: 'Plains',
        image: '/assets/images/pillows/ppPlainsT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Plains',
                image: '/assets/images/pillows/ppPlains.jpg'
            }
        ]
    },
    {
        id: 'shibori-9-patch',
        title: 'Shibori 9 Patch',
        image: '/assets/images/pillows/ppShibori9patchT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Shibori 9 Patch',
                image: '/assets/images/pillows/ppShibori9patch.jpg'
            }
        ]
    },
    {
        id: 'snowflake',
        title: 'Snowflake',
        image: '/assets/images/pillows/ppSnowflakeT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Snowflake',
                image: '/assets/images/pillows/ppSnowflake.jpg'
            }
        ]
    },
    {
        id: 'pp-spiral',
        title: 'Spiral',
        image: '/assets/images/pillows/ppSpiralT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Spiral',
                image: '/assets/images/pillows/ppSpiral.jpg'
            }
        ]
    },
    {
        id: 'splash',
        title: 'Splash',
        image: '/assets/images/pillows/ppSplashT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Splash',
                image: '/assets/images/pillows/ppSplash.jpg'
            },
            {
                image: '/assets/images/pillows/ppSplash2.jpg'
            }
        ]
    },
    {
        id: 'stencil-tree',
        title: 'Stencil Tree',
        image: '/assets/images/pillows/ppStencilTreeT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Stencil Tree',
                image: '/assets/images/pillows/ppStencilTree.jpg'
            }
        ]
    },
    {
        id: 'steps',
        title: 'Steps',
        image: '/assets/images/pillows/ppStepsT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Steps',
                image: '/assets/images/pillows/ppSteps.jpg'
            }
        ]
    },
    {
        id: 'virginia-star',
        title: 'Virginia Star',
        image: '/assets/images/pillows/ppVirginiaStarT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Virginia Star',
                image: '/assets/images/pillows/ppVirginiaStar.jpg'
            }
        ]
    },
    {
        id: 'woven',
        title: 'Woven',
        image: '/assets/images/pillows/ppWovenT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Woven',
                image: '/assets/images/pillows/ppWoven.jpg'
            }
        ]
    },
    {
        id: 'pp-wzz',
        title: 'Water Zig Zag',
        image: '/assets/images/pillows/ppWzzT.jpg',
        category: 'Patch Pillows',
        variations: [
            {
                title: 'Water Zig Zag',
                image: '/assets/images/pillows/ppWzz.jpg'
            }
        ]
    },
]